import React from 'react';
import './SupportHelpTableSkeleton.css';

const SupportHelpTableSkeleton = () => {
  return (
    <div className="support-table-skeleton-wrapper">
      <table className="support-table-skeleton">
        <thead>
          <tr>
            <th className="support-skeleton-th">
              <div className="support-skeleton-header" />
            </th>
            <th className="support-skeleton-th">
              <div className="support-skeleton-header" />
            </th>
            <th className="support-skeleton-th">
              <div className="support-skeleton-header" />
            </th>
            <th className="support-skeleton-th">
              <div className="support-skeleton-header" />
            </th>
            <th className="support-skeleton-th">
              <div className="support-skeleton-header" />
            </th>
            <th className="support-skeleton-th">
              <div className="support-skeleton-header" />
            </th>
            <th className="support-skeleton-th">
              <div className="support-skeleton-header" />
            </th>
          </tr>
        </thead>
        <tbody>
          {[...Array(8)].map((_, index) => (
            <tr key={index} className="support-skeleton-row">
              <td>
                <div className="support-skeleton-cell" />
              </td>
              <td>
                <div className="support-skeleton-cell-long" />
              </td>
              <td>
                <div className="support-skeleton-badge" />
              </td>
              <td>
                <div className="support-skeleton-cell" />
              </td>
              <td>
                <div className="support-skeleton-cell-long" />
              </td>
              <td>
                <div className="support-skeleton-cell" />
              </td>
              <td>
                <div className="support-skeleton-badge" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SupportHelpTableSkeleton;
